(function(){
"use strict";
/* Il blocco promozionale va inserito dentro il menu a tendina del
   tema, che viene disegnato dal tema stesso: lo agganciamo dopo
   l'elenco delle voci, senza toccare i file del tema. */
function metti(){
 var sorgente=document.getElementById("dmenuSorgente");
 if(!sorgente)return;
 var cassetti=document.querySelectorAll(".menu-drawer__navigation");
 for(var i=0;i<cassetti.length;i++){
  var c=cassetti[i];
  if(c.querySelector(".dmenu"))continue;
  var elenco=c.querySelector(".menu-drawer__menu");
  if(!elenco)continue;
  var blocco=sorgente.content.cloneNode(true);
  elenco.parentNode.insertBefore(blocco,elenco.nextSibling);
 }
}

if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",metti);
else metti();
addEventListener("load",metti);

/* il menu puo' essere ricostruito dal tema: si ricontrolla all'apertura */
document.addEventListener("click",function(e){
 if(e.target.closest(".header__icon--menu, .menu-drawer__close-button"))setTimeout(metti,120);
});
setTimeout(metti,900);
})();
